export default function LoadingPageIndicator() {
    return (
        <div className="d-flex align-items-center justify-content-center full-size">
            <div className="spinner-border" role="status">
                <span className="sr-only"></span>
            </div>
        </div>
    );
}
